import { SelectionModeType } from "_clients/BFFClient";

export type DistributionModePickProps = {
    productId: string;
    // productType: string;
    networkId: string;
    marketId: number;
}

export const MAX_DISPLAYED_CHIPS = 11;

export const switchChoices = [
    { key : SelectionModeType.Auto, label: "Automatique", value: SelectionModeType.Auto },
    { key : SelectionModeType.Manual, label: "Manuel", value: SelectionModeType.Manual },
];

export const XL_SCREEN_WIDTH = 1300;